<div>
  <form [formGroup]="form">
    <div formArrayName="pairs">
      @for (group of formArray.controls; track group; let i = $index) {
      <div [formGroupName]="i"
           class="row g-2 mb-2">
        <input type="text"
               formControlName="key"
               class="form-control col me-1"
               placeholder="Key" />
        <input type="text"
               class="form-control col me-1"
               formControlName="value"
               placeholder="Value" />
        <button type="button"
                class="btn btn-outline-primary border-0 btn-sm col-auto text-danger"
                [hidden]="!editing"
                (click)="removePair(i)">
          <fa-icon icon="trash"></fa-icon>
        </button>
      </div>
      }
    </div>
  </form>
  <div class="d-flex">
    @if (editing && allowEditing) {
    <button type="button"
            class="btn btn-primary mb-3"
            (click)="addPair()">Add row</button>
    
    <button type="button"
            class="btn btn-primary mb-3 ms-auto"
            (click)="submit()">Save</button>
    } @else {
    <button type="button"
            class="btn btn-primary mb-3 ms-auto"
            (click)="toggleEditing()">Edit</button>
    }
  </div>
</div>